module.exports = "/virtual-football-league/img/amblems/right/logos/BrightHoveAlbion.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/BrightHoveAlbion.png
// module id = 2163
// module chunks = 4